export enum MachineTypeEnum {
  TRACTOR = 'TRACTOR',
  SELF_PROPELLED = 'SELF_PROPELLED',
  COMBINE = 'COMBINE',
  TRUCK = 'TRUCK',
  FORAGE_HARVESTER = 'FORAGE_HARVESTER',
  MISC = 'MISC',
  SYREN = 'SYREN',
  TELEHANDLER = 'TELEHANDLER',
  WHEELLOADER = 'WHEELLOADER',
  EXCAVATOR = 'EXCAVATOR',
}
